<template>
  <div>
    <vue-loading v-if="loading"></vue-loading>
    <div v-if="loaded">
      <p class="date">{{ dateFormat(item.display_date) }}</p>
      <div class="area">{{ item.area }}</div>
      <h3 class="title">{{ item.title }}</h3>
      <div v-for="(item, index) in item.main_block" :key="index">
        <p v-if="item.fieldId === 'text_main'" class="text_main nl2br">
          {{ item.text_1 }}
        </p>

        <div v-if="item.fieldId === 'textleft_block'" class="textleft_block">
          <div class="text_left nl2br">
            {{ item.text_left }}
          </div>
          <div class="image_right">
            <img :src="item.image_right.url" /><span class="caption_right">{{
              item.caption_right
            }}</span>
          </div>
        </div>

        <div v-if="item.fieldId === 'textright_block'" class="textright_block">
          <div class="image_left">
            <img :src="item.image_left.url" /><span class="caption_left">{{
              item.caption_left
            }}</span>
          </div>
          <div class="text_right nl2br">
            {{ item.text_right }}
          </div>
        </div>

        <div
          v-if="item.fieldId === 'imagecenter_block'"
          class="imagecenter_block"
        >
          <div class="image_center">
            <img :src="item.image_center.url" /><span class="caption_center">{{
              item.caption_center
            }}</span>
          </div>
        </div>

        <div v-if="item.fieldId === 'image2_block'" class="image2_block">
          <div class="image2_left">
            <img :src="item.image2_left.url" /><span
              class="caption_image2_left"
              >{{ item.caption_image2_left }}</span
            >
          </div>
          <div class="image2_right">
            <img :src="item.image2_right.url" /><span
              class="caption_image2_right"
              >{{ item.caption_image2_right }}</span
            >
          </div>
        </div>

        <h4 v-if="item.fieldId === 'h4_block'" class="h4_block">
          {{ item.title_h4 }}
        </h4>

        <h5 v-if="item.fieldId === 'h5_block'" class="h5_block">
          {{ item.title_h5 }}
        </h5>

        <div
          v-if="item.fieldId === 'moviecenter_block'"
          class="moviecenter_block"
        >
          <div class="movie_center">
            <div v-html="item.movie_center"></div>
            <span class="caption_movie_center">{{
              item.caption_movie_center
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  name: 'AppCommunityDetail',
  props: {},
  data() {
    return {
      loading: true,
      loaded: false,
      item: null,
    }
  },
  created() {
    const urlParams = new URLSearchParams(location.search)
    const id = urlParams.get('id')
    const previewKey = urlParams.get('previewKey')
    const url = process.env.VUE_APP_CMS_API_BASE_URL
    const key = process.env.VUE_APP_CMS_API_KEY
    const params = {}
    if (previewKey !== null) {
      params.draftKey = previewKey
    }
    axios
      .get(url + '/community/' + id, {
        headers: {
          'X-API-KEY': key,
        },
        params,
      })
      .then((response) => {
        this.item = response.data
        this.loading = false
        this.loaded = true

        // titleタグの先頭に記事タイトルを追加
        document.title = this.item.title + '｜' + document.title
      })
      .catch(() => {
        this.loading = false
      })
  },
}
</script>

<style scoped>
.nl2br {
  white-space: pre-wrap;
}
</style>
